<template>
  <div class="c-base-radio" :class="[{ 'flex': this.stacked, 'inline-flex mr-4': !this.stacked }]">
    <input class="c-base-radio__input" type="radio" :name="name" :id="id" :value="value" v-model="localValue" :disabled="disabled">
    <label class="c-base-radio__label" :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
  export default {
    name: 'BaseRadio',

    model: {
      prop: 'checked',
      event: 'change'
    },

    props: {
      value: {
        type: String
      },
      checked: {
        type: String,
        default: null
      },
      name: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        id: `radio-${Math.random().toString(36).substring(2, 10)}`
      }
    },

    computed: {
      localValue: {
        get () {
          return this.checked
        },
        set (value) {
          this.$emit('change', value)
        }
      }
    }
  }
</script>
